module.exports = __webpack_public_path__ + "img/Sternenguckerin.a07213a6.jpg";